import { Button, Form, Input, InputNumber, message, notification, Select, TableColumnType } from "antd"
import moment from "moment"
import React, { ReactElement, useState } from "react"
import { DateTimeFormat, DateTimeFormatSimplePrintCharge } from "../../../../models/datetime"
import { Dimen } from "../../../../models/dimen"
import { getTreatmentPartsName, TreatmentPartsCategoris } from "../../../../models/setmeal"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import styles from './unexecutedPrescription.module.css'

export const Columns = (
  onClick: (text: string, t: any) => void,
  selectTabKey?: string,
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "组号",
      dataIndex: "groupNumber",
      align: "center",
      width: '4rem',
      ellipsis: true,
      render: (_, t) => {
        return t.groupNumber ? t.groupNumber : "-"
      },
    },
    {
      title: "处方名称",
      dataIndex: "recipeName",
      align: "center",
      width: '15rem',
      ellipsis: true,
      render: (_, t) => {
        return t.recipeName ? t.recipeName : "-"
      },
    },
    {
      title: "药品用法",
      dataIndex: "normalUsemethod",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normalUsemethod ? t.normalUsemethod : "-"
      },
    },
    {
      title: "每次用量",
      dataIndex: "normalDose",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normalDose ? t.normalDose : "-"
      },
    },
    {
      title: "频次",
      dataIndex: "normalFrequency",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normalFrequency ? t.normalFrequency : "-"
      },
    },
    {
      title: "数量",
      dataIndex: "drugCount",
      align: "center",
      width: '5rem',
      ellipsis: true,
      render: (_, t) => {
        return t.drugCount ? t.drugCount + (t.splitTag == 1 ? t.splitUnit : t.accountUnit) : "-"
      },
    },
    {
      title: "天数",
      dataIndex: "useDays",
      align: "center",
      width: '5rem',
      ellipsis: true,
      render: (_, t) => {
        return t.useDays ? t.useDays : "-"
      },
    },
    {
      title: "执行进度",
      dataIndex: "remainNum",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.drugType == 1 ? '-' : `${(t.totalNumberExecution == -1 ? 0 : t.totalNumberExecution)}/${t.num}` || "-"
      },
    },
    {
      title: "操作",
      align: "center",
      fixed: "right",
      width: "8rem",
      render: function Element(_, t) {
        return (
          // drugType 1诊疗
          <>
            {
              t?.drugType == 1 ?
                <>-</> :
                <>
                  {selectTabKey == '1' || t.totalNumberExecution == t?.num
                    ? ''
                    : <Button
                      style={{ marginRight: '6px' }}
                      type='primary'
                      size='small'
                      onClick={() => {
                        onClick('execute', t)
                      }}
                    >
                      执行
                    </Button>
                  }
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    onClick={() => {
                      onClick('record', t)
                    }}
                  >
                    记录
                  </Button>
                </>}
          </>
        )
      },
    },
  ]
}

export const RecordColumns = (
  onClick: (text: string, id: any, coherentVideo?: any) => void,
  startIndex?: number
): TableColumnType<any>[] => {

  return [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "执行次数",
      dataIndex: "executeNum",
      align: "center",
      width: '6rem',
      ellipsis: true,
    },
    {
      title: "执行时间",
      dataIndex: "executeTime",
      align: "center",
      width: '10rem',
      ellipsis: true,
      render: (_, t) =>
        t.executeTime ? moment(t.executeTime).format(DateTimeFormat) : "-",
    },
    {
      title: "执行人",
      dataIndex: "operatorName",
      align: "center",
      width: '9rem',
      ellipsis: true,
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: '8rem',
      ellipsis: true,
      align: "center",
      render: (_, t) => (t.remark ? t.remark : "-"),
    },
    {
      title: "附件",
      dataIndex: "",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <>
            {t.attachmentFile ? (
              <Button
                type='text'
                style={{ color: "#027aff" }}
                onClick={(e: any) => {
                  onClick("look", t.id, t.attachmentFile)
                }}
              >
                查看
              </Button>
            ) : (
              "-"
            )}
          </>
        )
      },
    },
    {
      title: "操作",
      dataIndex: "",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <>
            -
            {/* <Button
              type='link'
              style={{ color: "#027aff" }}
              onClick={(e: any) => {
                onClick("print", t.id)
              }}
            >
              打印
            </Button> */}
          </>
        )
      },
    },
  ]
}

export const ExcuteRecordColumns = (
  onClick: (text: string, val: any, e?: any) => void,
): TableColumnType<any>[] => {
  const { Option } = Select

  const columns: TableColumnType<any>[] = [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: '3rem',
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: "组号",
      dataIndex: "groupNumber",
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.groupNumber ? t.groupNumber : "-"
      },
    },
    {
      title: "处方名称",
      dataIndex: "recipeName",
      align: "center",
      width: '13rem',
      ellipsis: true,
      render: (_, t) => {
        return t.recipeName ? t.recipeName : "-"
      },
    },
    {
      title: "执行进度",
      dataIndex: "totalNumberExecution",
      key: 'totalNumberExecution',
      align: "center",
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return `${(t.totalNumberExecution == -1 ? 0 : t.totalNumberExecution)}/${t.num}` || "-"
      },
    },
    {
      title: "本次执行",
      dataIndex: "executeNum",
      align: "center",
      width: '7rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              width: '120px',
              border: '1px solid #d9d9d9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '2px',
            }}
              className={styles.executeNumMain}
            >
              <Button
                disabled={t.executeNum <= 0}
                style={{
                  border: 'none',
                  borderRight: '1px solid #d9d9d9',
                }}
                icon={<MinusOutlined />}
                onClick={() => {
                  const v = (t.executeNum || 0) - 1
                  onClick("changeExecuteNum", t, v)
                }}
              />
              <InputNumber
                style={{
                  border: 'none',
                  width: '3.5rem',
                  height: '32px',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
                value={t.executeNum}
                disabled={t.remainNum == 0}
                controls={false}
                onChange={(v: any) => {
                  const reg = new RegExp(/^[0-9]\d*$/)
                  if (!reg.test(v)) {
                    notification.info({
                      message: '请输入正整数',
                    })
                  }
                  onClick("changeExecuteNum", t, v)
                }}
              />
              <Button
                disabled={t.remainNum <= t.executeNum}
                style={{
                  border: 'none',
                  borderLeft: '1px solid #d9d9d9',
                }}
                icon={<PlusOutlined />}
                onClick={() => {
                  const v = (t.executeNum || 0) + 1
                  onClick("changeExecuteNum", t, v)
                }}
              />
            </div>
          </div >
        )
      },
    },
  ]

  return columns
}